import script from "./MessageItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./MessageItem.vue?vue&type=script&lang=ts&setup=true"

import "./MessageItem.vue?vue&type=style&index=0&id=1b93a397&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b93a397"]])

export default __exports__